import Vue from 'vue'
import { GetterTree } from 'vuex'
import { Module } from 'vuex'
import { ActionTree } from 'vuex'
import { MutationTree } from 'vuex'

const bus = new Vue()
interface RootState { }
interface BusState { }

const state: BusState = { }

const actions: ActionTree<BusState, RootState> = {
  emit ({ state }, payload) {
    bus.$emit(payload.event, payload.payload)
  },

  on ({ state }, payload) {
    bus.$on(payload.event, payload.callback)
  }
}

const getters: GetterTree<BusState, RootState> = {

}

const mutations: MutationTree<BusState> = {

}

export const store: Module<BusState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
